import { useState } from 'react';
import { useT } from '@hana/i18n';
import '../edu.i18n';
import { PageHeader } from '@hana/shell';
import { Button, Skeleton, StateView, useToast } from '@hana/ui';
import { COURSES } from '../data/courses';
import { SEATS, pathItems, pathOf } from '../data/path';
import { useEdu } from '../useEdu';
import s from '../edu.module.css';

// Màn Lộ trình theo ghế (board Mint-Training, app `path`): cột ghế bên trái, các chặng + khoá của ghế đang chọn bên phải.

function PathBody({ mine }: { mine: string }) {
  const [seat, setSeat] = useState(mine);
  const steps = pathOf(seat);
  const flat = pathItems(steps);
  const done = flat.filter((x) => x.done).length;
  const seatName = SEATS.find((x) => x.code === seat)?.k ?? '';
  return (
    <div className={s.pathWrap}>
      <section className={`${s.card} ${s.seats}`} aria-label="Ghế">
        {SEATS.map((x) => (
          <button key={x.code} type="button" aria-pressed={seat === x.code} title={x.k} onClick={() => setSeat(x.code)}>
            <i data-me={x.code === mine ? '1' : undefined} />
            <span>{x.code}</span>
            <em>
              <svg aria-hidden="true" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2 M10 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" /></svg>
              {x.n}
            </em>
          </button>
        ))}
      </section>
      <section className={`${s.card} ${s.pathCard}`} aria-label="Lộ trình">
        <div className={s.colHead}>
          <h2 className={s.h2}>{seat} · {seatName}</h2>
          <span className={s.info} role="img" title="Hoàn thành khoá không tự mở quyền thao tác · người kiêm nhiệm nhận lộ trình của mọi ghế đang giữ" aria-label="Chú thích">i</span>
          <span className={s.pathSum}>{done}/{flat.length}</span>
        </div>
        <div className={s.pathBar} role="img" aria-label={`Đã xong ${done} trên ${flat.length} khoá của lộ trình`}>
          {flat.map((x, i) => <div key={i} data-on={x.done ? '1' : undefined} />)}
        </div>
        {steps.map((p, i) => (
          <div key={p.k} className={s.step}>
            <div className={s.stepL}>
              <span className={s.stepDot} data-first={i === 0 ? '1' : undefined}>{i + 1}</span>
              {i < steps.length - 1 && <span className={s.stepLine} />}
            </div>
            <div className={s.stepR}>
              <div className={s.stepHead}><b>{p.k}</b><span>{p.when}</span></div>
              <div className={s.stepItems}>
                {p.items.map((x) => <span key={x.k}><i data-on={x.done ? '1' : undefined} />{x.k}<span>{x.d}</span></span>)}
              </div>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}

export function PathScreen() {
  const t = useT();
  const { state, learner } = useEdu();
  const toast = useToast();
  return (
    <>
      <PageHeader
        title="Lộ trình theo ghế"
        actions={state === 'ready' ? <Button variant="primary" onClick={() => toast({ msg: `Mở khoá: ${COURSES[0]!.short}` })}>{t('ed.continue')}</Button> : undefined}
      />
      <StateView
        state={state}
        title={state === 'empty' ? 'Chưa có lộ trình cho ghế này' : undefined}
        skeleton={<div className={s.skel}><Skeleton rows={5} /></div>}
      >
        <div className={s.page}><PathBody mine={learner.seat} /></div>
      </StateView>
    </>
  );
}
